import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Icons from '../assets/icons';
import GenericTableComponent from '../genericComponents/tableComponent/GenericTableComponent';
import GenericStatusComponent from '../genericComponents/GenericStatusComponent';
import { getPermissionKey } from '../helper/permissions';
import { Check, Hourglass, Info } from 'lucide-react';
import GenericCustomButton from '../genericComponents/GenericCustomButton';
import ParentModal from '../genericComponents/ParentModal';
import AppliedFiltersSidebarModal from '../genericComponents/AppliedFiltersSidebarModal';
import { Funnel } from 'recharts';

function DataExportLogs(props) {
    const generalStore = useSelector(state => state.generalStore);

    const tableHeadersMap = {
        main: {
            name: "Main",
            key: "EXCEL_EXPORT_LOG"
        }
    }

    const [selectedModal, setSelectedModal] = useState(null)
    const [selectedData, setSelectedData] = useState({});

    const getParentChildProps = () => {
        switch(selectedModal){
            case "appliedFilters" : {
                return{
                    closeModal: () => { setSelectedModal(null) },
                    parentModalOuterMostClassName: 'flex items-center justify-center',
                    postitionProps: { top: 0, bottom: 0, left: "auto", right: 0, transform: "none", position: "absolute", margin: 0, borderRadius: 0 },
                    dimensions: {width: "450px", height: "100vh" },
                    animationType: "right",
                    selectedData : selectedData
                }
            }
        }
    }

    const getChildComponent = () => {
        switch(selectedModal){
            case "appliedFilters" : return AppliedFiltersSidebarModal;

            default:
        }
    }

    return (
        <div className='dataExportLogs'>
            <GenericTableComponent

                tableConfig={{
                    extras: item => <React.Fragment>
                        <li data-interactive="true" onClick={() => item?.file_url ? window.open(item.file_url) : null} className={`ml-1.5 ${!item?.file_url ? 'til-inner opacity04' : 'til-inner til-copy-btn'}`}>
                            <span>
                                <Icons.BlueDownloadIcon />
                            </span>
                        </li>
                    </React.Fragment>,
                    customCols: {
                        status: item => <div className='flex items-center gap-2'>
                                <GenericStatusComponent status={item?.["status"]} />
                                {item?.["status"]?.toString().toLowerCase() === 'pending' && <div className='hourglass-anim'>
                                    <Hourglass color='#718098' size={15} strokeWidth={1} />
                                </div>}
                            </div>,
                        fileName: item => <div className='flex items-center justify-between gap-5'>
                                            <div className='relative group flex items-center gap-2'>
                                                <div><Icons.LogIcon/></div>
                                                <p className='mb-0 text-xs text-[#111d31]'>{item?.fileName}</p>
                                                <div className='generic-tooltip tooltip-right !p-[10px] !text-start !break-words !whitespace-normal !max-w-[250px] group-hover:visible group-hover:opacity-100'>
                                                    <p className='!mb-3 !text-xs !font-bold !text-[#A0A0A0]'>{item?.fileName}</p>
                                                    <p className='!mb-2 !text-xs !font-bold !text-white'>Exported File -</p>
                                                    <p className='!text-xs !font-normal !text-white'>{item?.uuid}_{item?.group_name}</p>
                                                </div>
                                            </div>
                                            {(item?.filter_condition && typeof JSON.parse(item.filter_condition) === 'object' && Object.keys(JSON.parse(item.filter_condition)).length > 0) && 
                                                <GenericCustomButton
                                                    // type='default'
                                                    leftIcon={<div className='relative'><div><Icons.GCFilterIcon height={17} width={17}/></div><div className='absolute top-[3px] right-[0px] p-[1px] bg-primary rounded-full'><Check color='white' strokeWidth={5} size={6} /></div></div>}
                                                    tooltip='Open Filter Details'
                                                    label={'Filtered'}
                                                    size={'small'}
                                                    className={'flex items-center gap-1.5 h-[26px] text-[11px] font-medium bg-primary_w_less_opacity rounded-[3px] text-fontBlack px-2 hover:opacity-75'}
                                                    onClick={()=>{setSelectedModal('appliedFilters'); setSelectedData(item)}}
                                                />
                                            }
                                        </div>
                    }
                }}
                tableComExtraHeaders={getPermissionKey("common", "commonFunctionality", "view")}
                tableDataPayload={{
                    type: 1,
                    pageNo: 1,
                    pageSize: 10,
                    sortedBy: "",
                    sortedIn: "",
                    search: "",
                    filter: {},
                    apiUrl: "/core/org/data/export/getAll"
                }}

                tableData={generalStore?.getTableComponentListData?.data?.resource ?
                    {
                        data: generalStore?.getTableComponentListData?.data?.resource?.data || [],
                        totalItems: generalStore?.getTableComponentListData?.data?.resource?.totalRecord || 0,
                        currentPage: generalStore?.getTableComponentListData?.data?.resource?.currPage || 1,
                        maxPage: generalStore?.getTableComponentListData?.data?.resource?.maxPage || 1,
                        getTableApiData: generalStore?.getTableComponentListData?.data?.resource || []
                    } :
                    {
                        data: [],
                        totalItems: 0,
                        currentPage: 1,
                        maxPage: 1
                    }
                }
                tableHeadersMap={tableHeadersMap}
                tableHeadersPayload={tableHeadersMap}
                availableStores={["generalStore"]}
            />
            {
                selectedModal && <ParentModal
                    getParentChildProps={getParentChildProps()}
                    childComponent={getChildComponent()}
                    closeModal={() => { setSelectedModal(false) }}
                />
            }
        </div>
    )
}

export default DataExportLogs;